import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  youtubeCookiesAccepted: false,
  jobsNotificationsEnabled: false,
};

const misc = createSlice({
  name: 'misc',
  initialState,
  reducers: {
    setYoutubeCookieConsent(state, { payload }) {
      state.youtubeCookiesAccepted = payload;
    },
    enableJobsNotifications(state) {
      state.jobsNotificationsEnabled = true;
    },
  },
});

export const { enableJobsNotifications, setYoutubeCookieConsent } =
  misc.actions;

export default {
  [misc.name]: misc.reducer,
};
